import { takeRequestBlogPostsSaga } from "./takeRequestBlogPosts";
import { takeRequestCategoriesSaga } from "./takeRequestCateogires";
import { takeGetRankingsSaga } from "./takeGetRankings";

export const sagas = [
  takeRequestBlogPostsSaga,
  takeRequestCategoriesSaga,
  takeGetRankingsSaga,
];
